import { ENTITY_TYPE } from '../../../../common/constants/TaxonomyConstants';

export const controlDetailsTemplate = [
	{
		label: 'Frequency',
		value: '-',
	},
	{
		label: 'Type',
		value: '-',
	},
	{
		label: 'Purpose',
		value: '-',
	},
	{
		label: 'Key Control',
		value: '-',
	},
];

export const processDetailsTemplate = [
	{
		label: 'Owner',
		value: '-',
	},
	{
		label: 'Type',
		value: '-',
	},
	{
		label: 'Industry',
		value: '-',
	},
	{
		label: 'Date Created',
		value: '-',
	},
	{
		label: 'Date Modified',
		value: '-',
	},
	{
		label: 'Covered Products',
		value: '-',
	},
];

export const RiskDetailsTemplate = [
	{
		label: 'Type',
		value: '-',
	},
	{
		label: 'Category',
		value: '-',
	},
	{
		label: 'Owner',
		value: '-',
	},
	{
		label: 'Business Unit',
		value: '-',
	},
	{
		label: 'Status',
		value: '-',
	},
	{
		label: 'Date Created',
		value: '-',
	},
	{
		label: 'Date Modified',
		value: '-',
	},
];

export const controlDetailsMappingObj: any = {
	Frequency: 'frequency',
	Type: 'type',
	Purpose: 'purpose',
	'Key Control': 'keyControl',
};

export const processDetailsMappingObj: any = {
	Owner: 'owner',
	Type: 'type',
	Industry: 'industry',
	'Date Created': 'createdDate',
	'Date Modified': 'modifiedDate',
	'Covered Products': 'productCount',
};

export const RiskDetailsMappingObj: any = {
	Type: 'type',
	Category: 'category',
	Owner: 'owner',
	'Business Unit': 'riskBusinessUnit',
	Status: 'riskStatus',
	'Date Created': 'createdDate',
	'Date Modified': 'modifiedDate',
};

export const getEntityDetailTemplate = (entityType: string) => {
	switch (entityType) {
		case ENTITY_TYPE.CONTROL:
			return controlDetailsTemplate;
		case ENTITY_TYPE.RISK:
			return RiskDetailsTemplate;
		case ENTITY_TYPE.PROCESS:
			return processDetailsTemplate;
		default:
			return [];
	}
};

export const getDetailsMappingObj = (entityType: string) => {
	switch (entityType) {
		case ENTITY_TYPE.CONTROL:
			return controlDetailsMappingObj;
		case ENTITY_TYPE.RISK:
			return RiskDetailsMappingObj;
		case ENTITY_TYPE.PROCESS:
			return processDetailsMappingObj;
		default:
			return {};
	}
};

export const getEntityDetailTagsTemplate = (entityType: string, data: any) => {
	switch (entityType) {
		case ENTITY_TYPE.CONTROL:
			return data.metadataTag && data.metadataTag?.length > 0
				? data?.metadataTag.split(',')
				: [];
		case ENTITY_TYPE.RISK:
		case ENTITY_TYPE.PROCESS:
			return data.tags && data.tags?.length > 0 ? data?.tags.split(',') : [];
		default:
			return [];
	}
};

export const getLevelInfo = (data: any) => {
	const levelArr: {
		key: string;
		value: string;
	}[] = [];
	const levelList: string[] = [];
	Object.keys(data).forEach((key) => {
		if (key.toLowerCase().includes('level') && data[key])
			levelArr.push({
				key,
				value: data[key],
			});
	});
	levelArr.forEach((_, index) => {
		const item = levelArr.find((level) =>
			level.key.includes(String(index + 1)),
		)?.value;
		if (item) levelList.push(item);
	});
	return levelList;
};
